// react
import styled from 'styled-components';

// components
import { Button } from '@/components/atoms';

interface BackButtonProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  variant?: 'primary' | 'secondary' | 'link';
  label?: string;
  isNoMargin?: boolean;
}

/**
 * BackButton navigates back in the browser history.
 */
export const BackButton = ({
  className,
  size = 'sm',
  variant = 'secondary',
  label = 'Back',
  isNoMargin = false,
}: BackButtonProps) => {
  return (
    <Wrapper className={className} $isNoMargin={isNoMargin}>
      <Button
        ariaLabel='back'
        variant={variant}
        onPress={() => window.history.back()}
        iconLeft={'chevron-left'}
        size={size}
      >
        {label}
      </Button>
    </Wrapper>
  );
};

interface WrapperProps {
  $isNoMargin?: boolean;
}
const Wrapper = styled.div<WrapperProps>`
  margin-bottom: ${(props) => !props.$isNoMargin && props.theme.spacing[24]};
`;

BackButton.displayName = 'BackButton';

export default BackButton;
